import React, { useState } from "react";
import Logo from "../Assets/images/defillama.webp";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { GoGear } from "react-icons/go";
import { MdKeyboardArrowDown } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import {
  HiOutlineHome,
  HiOutlineChartBar,
  HiOutlineCube,
  HiOutlineUser,
  HiOutlineGlobeAlt,
  HiOutlinePresentationChartLine,
  HiOutlineDatabase,
  HiOutlineTable,
  HiOutlineSupport,
} from "react-icons/hi";
import { RiCopperCoinLine } from "react-icons/ri";
import { FaTerminal } from "react-icons/fa";
import StrategiesBody from "./StrategiesBody";

const mainNav = [
  { name: "Home", icon: <HiOutlineHome size={20} /> },
  { name: "Metrics", icon: <HiOutlineChartBar size={20} /> },
  { name: "Tools", icon: <FaTerminal size={18} /> },
  { name: "Pricing", icon: <HiOutlineUser size={20} /> },
  { name: "Chains", icon: <HiOutlineGlobeAlt size={20} /> },
  { name: "Yields", icon: <HiOutlinePresentationChartLine size={20} /> },
  { name: "Stablecoins", icon: <RiCopperCoinLine size={20} /> },
  { name: "Custom Dashboards", icon: <HiOutlineCube size={20} /> },
  { name: "LlamaAI", icon: <HiOutlineDatabase size={20} /> },
  { name: "Sheets", icon: <HiOutlineTable size={20} /> },
  { name: "Support", icon: <HiOutlineSupport size={20} /> },
];

const moreNav = [
  "Support",
  "Careers",
  "Report Incorrect Data",
  "Press / Media",
  "API Reference",
  "List your project",
  "Data Definitions",
];

const SwapCard = ({ setShowModal }) => {
  const [activeTab, setActiveTab] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);

  const Sidebar = () => (
    <div className="relative flex flex-col w-full h-full overflow-y-auto text-gray-300 bg-red-400 border-r border-gray-800 lg:w-64">
      {/* Sidebar Header */}
      <div className="flex items-center justify-between p-4 lg:p-6">
        {/* Close Button - Top Right in Mobile Sidebar */}
        <IoMdClose size={24} className="opacity-0" />

        <button
          onClick={() => setMobileOpen(false)}
          className="p-1 text-white border border-gray-600 rounded lg:hidden"
        >
          <IoMdClose size={24} />
        </button>
      </div>

      <div className="px-3 space-y-6">
        <div>
          <p className="px-3 mb-2 text-xs font-semibold tracking-wider text-gray-500 uppercase">
            Main
          </p>
          <div className="space-y-1">
            {mainNav.map((item) => (
              <button
                key={item.name}
                onClick={() => {
                  setActiveTab(item.name);
                  setMobileOpen(false);
                }}
                className={`flex items-center gap-3 w-full px-3 py-2 text-[15px] rounded-lg transition-all ${
                  activeTab === item.name
                    ? "bg-[#2d2f36] text-white"
                    : "hover:bg-[#24262b] hover:text-white"
                }`}
              >
                <span
                  className={
                    activeTab === item.name ? "text-white" : "text-gray-400"
                  }
                >
                  {item.icon}
                </span>
                {item.name}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-between px-3 py-2 text-sm font-medium border-t border-gray-800 cursor-pointer hover:text-white">
          <span>Old Menu</span>
          <MdKeyboardArrowDown size={20} />
        </div>

        <div className="pt-4 border-t border-gray-800">
          <p className="px-3 mb-2 text-xs font-semibold tracking-wider text-gray-500 uppercase">
            More
          </p>
          <div className="pb-10 space-y-1">
            {moreNav.map((item) => (
              <button
                key={item}
                className="w-full text-left px-3 py-2 text-[15px] text-gray-400 hover:text-white hover:bg-[#24262b] rounded-lg transition"
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex h-screen bg-[#111214] overflow-hidden">
      {/* Desktop Sidebar */}
      <aside className="hidden shrink-0">
        <Sidebar />
      </aside>

      {/* Mobile Sidebar Overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-[60] lg:hidden bg-black/80 backdrop-blur-sm flex justify-end">
          <div className="h-full duration-300 w-72 animate-in slide-in-from-right">
            <Sidebar />
          </div>
        </div>
      )}

      {/* Main Content Area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        {/* Top Header */}
        <header className="h-14 flex items-center justify-between px-6 bg-[#3A4D98] border-b border-gray-800">
          <div className="">
            <img src={Logo} alt="logo" className="w-auto h-10" />
          </div>

          <div className="flex items-center gap-2 text-gray-400">
            <button className="p-2 bg-[#5065CF] text-white rounded">
              <CiSearch size={20} />
            </button>
            <button className="p-2 bg-[#5065CF] text-white rounded">
              <GoGear size={20} />
            </button>

            {/* Hamburger Menu on RIGHT side for Mobile */}
            <button
              onClick={() => setMobileOpen(true)}
              className="p-1 bg-[#5065CF] text-white rounded transition lg:hidden hover:bg-gray-800"
            >
              <IoMdMenu size={28} />
            </button>
          </div>
        </header>

        {/* Content Scroll Area */}
        <div className="flex-1 overflow-y-auto">
          <div className="w-full">
            <StrategiesBody setShowModal={setShowModal} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwapCard;
